// extracted by mini-css-extract-plugin
export var divider = "_k6-0";
export var systemMessage = "_k6-1";